export function cleanSubtitleText(input: string): string {
  return decodeHtmlEntities(stripHtmlTags(input))
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export function extractTextFromRichContent(content: unknown): string {
  if (typeof content !== "string" || content.trim() === "") {
    return "";
  }

  const trimmed = content.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
    return trimmed;
  }

  try {
    const parsed = JSON.parse(trimmed) as unknown;
    const text = findTextField(parsed);
    return typeof text === "string" ? text : trimmed;
  } catch {
    return trimmed;
  }
}

function findTextField(value: unknown): unknown {
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = findTextField(item);
      if (typeof found === "string" && found.length > 0) {
        return found;
      }
    }
    return undefined;
  }

  if (!value || typeof value !== "object") {
    return undefined;
  }

  const object = value as Record<string, unknown>;
  if (typeof object.text === "string") {
    return object.text;
  }

  for (const child of Object.values(object)) {
    const found = findTextField(child);
    if (typeof found === "string" && found.length > 0) {
      return found;
    }
  }

  return undefined;
}

function stripHtmlTags(input: string): string {
  return input.replace(/<[^>]*>/g, "");
}

function decodeHtmlEntities(input: string): string {
  return input
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, "\"")
    .replace(/&#39;/g, "'");
}
